<div class="retailprice-list">
  <table mat-table [dataSource]="datasource" matSort (matSortChange)="announceSortChange($event)">

      <ng-container matColumnDef="valid-from">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.valid-from"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.from | date: 'dd.MM.yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="valid-until">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.valid-until"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.until  | date: 'dd.MM.yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="price-net">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by weight">
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.price-net"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceNet | numberFormat:priceScale}} </td>
      </ng-container>

      <ng-container matColumnDef="tax-rate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.tax-rate"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.taxRate}} </td>
      </ng-container>

      <ng-container matColumnDef="price-vat">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.price-vat"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceVat | numberFormat:priceScale}} </td>
      </ng-container>

      <ng-container matColumnDef="reference-date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor-retailprices.table.retailprice.referencedate"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.referenceDate}} </td>
      </ng-container>

      <ng-container matColumnDef="commands">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element;let i = index">
              <button mat-icon-button (click)="editRetailPrice(element, i)">
                  <sc-icon iconClass="fa-pencil"></sc-icon></button>
              <button mat-icon-button (click)="removeRetailPrice(element, i)">
                  <sc-icon iconClass="fa-trash"></sc-icon>
              </button>
          </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>
</div>
